import { INTERVIEWER } from '@/lib/interviewer/config';

export const FAQ_ITEMS = [
  {
    q: 'Does the person being interviewed need to be tech-savvy?',
    a: 'No. Interviews happen over an ordinary phone call or in a normal web browser. On the phone, they just pick up and talk. There’s no app, no link, and no smartphone needed. In the browser, it’s one tap to start, with a live transcript on screen so they can see they’re being heard. Text works too. Whatever works for you.',
  },
  {
    q: `Can ${INTERVIEWER.name} call my mom directly?`,
    a: `Yes. Send a phone invitation and ${INTERVIEWER.name} calls at the time you choose. She introduces herself, explains who asked her to call and why, and asks permission before recording anything. If your mom says yes, the interview starts right there.`,
  },
  {
    q: 'Which plans include phone interviews?',
    a: `Every plan. You can call ${INTERVIEWER.name} at her number, have her call you on a schedule you choose, or invite a relative by phone.`,
  },
  {
    q: 'How long is a guided interview?',
    a: 'As little as 5 minutes, as long as you want. Stoppable at any point. Sessions pick up where the last one left off, so you can contribute daily, weekly, monthly, or whenever you have some time.',
  },
  {
    q: 'What’s actually in the record?',
    a: 'Four things, all generated from the same transcripts: narrative chapters telling the story of their life, a timeline of key dates and places, an index of people, and a photo library with auto-generated captions and links to your conversations and chapters.',
  },
  {
    q: 'Can I print it as a book?',
    a: 'Yes. A beautiful full-color hardcover. And unlike a memoir that’s finished the day it’s printed, yours is never done: add a new story, voice, or photo any time, and reprint it as it grows.',
  },
  {
    q: 'Can I order copies for the rest of the family?',
    a: 'Yes. Order as many hardcovers as you like, one for each child, grandchild, or branch of the family. Everyone holds their own copy of the same story.',
  },
  {
    q: 'Can I give it as a gift?',
    a: 'It’s one of the most meaningful gifts there is. Give the finished hardcover, or start a biography as a gift and invite the family to help fill it in.',
  },
  {
    q: 'How long does the book take to arrive?',
    a: 'Once you’re happy with it, your book is printed in full color and shipped to your door. You’ll see production and delivery estimates before you order.',
  },
  {
    q: 'Can multiple people contribute?',
    a: 'Yes. You can invite as many other co-contributors as you like. Each person can participate in guided interviews, read and browse the biography, comment on shared memories, and add photos. Every contribution is attributed.',
  },
  {
    q: 'What if the system gets something wrong?',
    a: `Making corrections is as easy as talking with ${INTERVIEWER.name}. Start a conversation and correct the record, add to it, or make a clarification. ${INTERVIEWER.name} will listen and capture the details.`,
  },
  {
    q: 'Can we talk in a language other than English?',
    a: `Yes. ${INTERVIEWER.name} can hold a conversation in more than 70 languages, including Spanish, Chinese, Vietnamese, Korean, Tagalog, and Russian. Conversations start in English. Ask to switch, or just start speaking your language, and ${INTERVIEWER.name} will follow. The written biography itself (chapters, timeline, and the printed book) is currently produced in English.`,
  },
  {
    q: 'How much does it cost?',
    a: 'Plans start at $49 a year for the digital biography. Our most popular plan, Keepsake, is $99 a year and includes a hardcover book; Family is $199 a year and includes three hardcover books, the best value if you’re ordering for the whole family. Every plan comes with a 30-day money-back guarantee.',
  },
  {
    q: 'What happens if I stop paying?',
    a: 'Everything you share is yours, always. If you ever stop, your biography stays readable and yours to keep. We’ll never lock you out. And you can export your data any time you like.',
  },
] as const;
